import React from 'react';
import './criticalStyles.css';

interface LazyLoadFallbackProps {
  message?: string;
}

export const LazyLoadFallback: React.FC<LazyLoadFallbackProps> = ({ 
  message = "Chargement..." 
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: 'hsl(45, 15%, 96%)',
      padding: '1rem'
    }}>
      <div style={{
        background: 'hsl(0, 0%, 100%)',
        border: '1px solid hsl(214.3, 31.8%, 91.4%)',
        borderRadius: '0.75rem',
        padding: '2rem',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%'
      }}>
        {/* Spinner critique avec CSS inline */}
        <div style={{
          display: 'inline-block',
          width: '40px',
          height: '40px',
          border: '3px solid hsl(214.3, 31.8%, 91.4%)',
          borderRadius: '50%',
          borderTopColor: 'hsl(25, 100%, 50%)',
          animation: 'spin 0.8s linear infinite',
          marginBottom: '1rem'
        }}></div>
        
        <p style={{ 
          fontSize: '0.875rem', 
          fontWeight: '500',
          color: 'hsl(222.2, 84%, 4.9%)',
          marginBottom: '0.5rem'
        }}>
          {message}
        </p>
        <p style={{ 
          fontSize: '0.75rem', 
          opacity: '0.7',
          color: 'hsl(222.2, 84%, 4.9%)'
        }}>
          Optimisation en cours...
        </p>
      </div>
    </div>
  );
};

export default LazyLoadFallback;